// @flow
import { createStore, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
import reducers from './reducers';
import rootSaga from './sagas';
import { persistWorkSession } from './workSession/reducers';

const sagaMiddleware = createSagaMiddleware();
const middlewares = [sagaMiddleware];

export function configureStore(initialState: {}): any {
    let store;

    if (window['__REDUX_DEVTOOLS_EXTENSION_COMPOSE__']) {
        store = createStore(reducers, initialState, window['__REDUX_DEVTOOLS_EXTENSION_COMPOSE__'](applyMiddleware(...middlewares)));
    } else {
        store = createStore(reducers, initialState, applyMiddleware(...middlewares));
    }
    sagaMiddleware.run(rootSaga);

    // Eine laufende Arbeitssitzung uebersteht damit ein Neuladen der Seite.
    // Referenzvergleich: der Reducer gibt bei fremden Aktionen denselben Zustand
    // zurueck, also wird nur beim tatsaechlichen Wechsel geschrieben.
    let lastWorkSession = store.getState().WorkSession;
    store.subscribe(() => {
        const current = store.getState().WorkSession;
        if (current === lastWorkSession) return;
        lastWorkSession = current;
        persistWorkSession(current);
    });

    return store;
}
